import bnbImg from "../assets/img/bnb.jpeg";
import tsImg from "../assets/img/ts.jpeg";
import neoImg from "../assets/img/neo.jpeg";
import osfImg from "../assets/img/osfdigital.jpeg";

export const experiences = [
  {
    id: "osf-digital",
    company: "OSF Digital",
    period: "Oct 2022 - Present",
    type: "Full time",
    role: "Front End and Mobile Developer",
    technologies: [
      "React",
      "TypeScript",
      "JavaScript",
      "React Native",
      "Next JS",
      "HTML5",
      "Tailwind",
      "CSS3",
      "npm",
      "Git",
      "Bootstrap",
      "Context API",
      "React Router",
      "Axios",
      "Styled Components",
    ],
    logo: osfImg,
  },
  {
    id: "neo-ventures",
    company: "Neo Ventures",
    period: "Oct 2021 - Oct 2022 (1 year)",
    type: "Full time",
    role: "Front End Developer",
    technologies: [
      "React",
      "JavaScript",
      "HTML5",
      "CSS3",
      "npm",
      "Git",
      "Bootstrap",
      "Context API",
      "React Router",
      "Axios",
      "Styled Components",
    ],
    logo: neoImg,
  },
  {
    id: "teamsoft",
    company: "TeamSoft Tecnologia e Sistemas",
    period: "Apr 2021 - Oct 2021 (7 months)",
    type: "Part-time",
    role: "Front End and Mobile Developer",
    technologies: [
      "React",
      "JavaScript",
      "React Native",
      "HTML5",
      "CSS3",
      "npm",
      "Git",
      "Bootstrap",
      "Material UI",
      "Axios",
      "Redux",
      "React Router",
    ],
    logo: tsImg,
  },
  {
    id: "bnb",
    company: "Banco do Nordeste do Brasil S.A",
    period: "Nov 2020 - Aug 2021 (10 months)",
    type: "Trainee",
    role: "Web Developer Trainee",
    technologies: [
      "React",
      "JavaScript",
      "HTML5",
      "CSS3",
      "SQL",
      "SQL Server",
      "Material UI",
      "npm",
      "Git",
    ],
    logo: bnbImg,
  },
];
